import {PreOrderRetrieveResponse} from '@logistics-frontend/types/schemas/services/delivery-corp-account-api/api/pre-order'
import {SuggestAction} from '@yandex-delivery/api/model/suggest'
import {SuggestService} from '@yandex-delivery/api/service/suggest'

import {ReturnPoint} from '../../../../types'
import {fromPinDropToPointAddress} from '../../../../utils'
import {toSuggestLocation} from '../mappers/to-suggest-location'

export const fetchReturnPoint = async (
  {fetchAddressSuggest}: SuggestService,
  preOrderRetrieve: PreOrderRetrieveResponse,
): Promise<ReturnPoint | undefined> => {
  const returnPoint = preOrderRetrieve.claim.route_points?.filter(point => point.type === 'return')[0]

  if (!returnPoint) return

  const addressSuggest = await fetchAddressSuggest({
    point: toSuggestLocation(returnPoint.address.coordinates),
    type: 'b',
    location: toSuggestLocation(returnPoint.address.coordinates),
    action: SuggestAction.PIN_DROP,
  })

  return {
    _type: 'return',
    _id: returnPoint.point_id,
    _visitOrder: returnPoint.visit_order,
    externalID: '',
    contact: returnPoint.contact,
    address: fromPinDropToPointAddress(addressSuggest) ?? {},
  }
}
